import Token from '@/utils/Token';
import Mask from '@/utils/Mask';

export default {
    parse(data) {
        ['ativo'].forEach(item => {
            data[item] = parseInt(data[item]);
        });

        ['documento'].forEach(item => {
            if(data[item]) {
                if(data.pessoa == 'J') {
                    data[item] = Mask.cnpj(data[item]);
                } else {
                    data[item] = Mask.cpf(data[item]);
                }
            }
        });

        return data;
    },

    get(id, params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/provedor/${id}${params}`, Token.getHeader());
    },
    list(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/provedor/list${params}`, Token.getHeader());
    },
    download(params="") {
        if(params) params = `?${params}`;
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/provedor/download${params}`, headers);
    },
    option(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/provedor/option${params}`, Token.getHeader());
    },

    beneficiarioMapa(params="") {
        if(params) params = `?${params}`;
        return axios.get(`/api/provedor/beneficiario-mapa${params}`, Token.getHeader());
    },
    beneficiarioSalvar(params) {
        return axios.post(`/api/provedor/beneficiario-salvar`, params, Token.getHeader());
    },
    beneficiarioRemover(params) {
        return axios.delete(`/api/provedor/beneficiario-remover`, { ...Token.getHeader(), data: params });
    },

    create(params) {
        return axios.post(`/api/provedor`, params, Token.getHeader());
    },
    update(id,params) {
        return axios.post(`/api/provedor/${id}`, params, Token.getHeader());
    },
    delete(id) {
        return axios.delete(`/api/provedor/${id}`, Token.getHeader());
    },
}
